"use strict";

exports.__esModule = true;
exports.dataAttributes = void 0;
var dataAttributes = exports.dataAttributes = {
  draggableTarget: 'data-draggable-target',
  draggableSource: 'data-draggable-source',
  id: 'data-id',
  depth: 'data-depth'
};
//# sourceMappingURL=constants.js.map